export const MAX_AGE = 16;
export const DEFAULT_REGISTRATION_AGE = 18;
export const NICKNAME_PATTERN = /^[a-zA-Z0-9_]{3,16}$/;

export enum ENTITIES {
  student = 'child',
  parent = 'parent',
  teacher = 'teacher',
}
